<template>
	<AsiDialogFormLayout :icon="icons.paymentType" :title="$t('customer.defaultPaymentType')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors" @save="requestSave"
	                     @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-row>
				<v-col>
					<AsiRadioGroup v-model="model" :disabled="loading" class="ma-0 pa-0">
						<v-list class="pa-0">
							<v-list-item v-for="paymentType in paymentTypes" :key="paymentType.id" @click="model = paymentType.id">
								<v-list-item-action>
									<v-radio :value="paymentType.id"/>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>
										{{ paymentTypeName(paymentType) }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</AsiRadioGroup>
				</v-col>
			</v-row>
		</v-card-text>
	</AsiDialogFormLayout>

</template>

<script lang="ts">
	import {Component, Prop, Emit, Watch} from 'vue-property-decorator';
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import {ICustomerShop} from "@/models/customer/CustomerShopModels";
	import {ICustomerAdmin} from "@/models/customer/CustomerAdminModels";
	import {IPaymentTypeShop, IPaymentTypeShopListEntry} from "@/models/payment-type/PaymentTypeShopModels";
	import AsiRadioGroup from "@/components/common/AsiRadioGroup";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import Snackbar from "@/helpers/Snackbar";

	@Component({
		components: {AsiRadioGroup, AsiDialogFormLayout}
	})
	export default class CustomerUpdateDefaultPaymentTypeDialog extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public customer!: ICustomerShop

		private model: string | null = null;
		private paymentTypes: IPaymentTypeShop[] | null = null;

		public mounted(): void {
			this.loadPaymentTypes();
			this.setCustomerInternal();
		}

		@Watch('customer', {deep: true})
		private onCustomerChanged(): void {
			this.setCustomerInternal();
		}

		private setCustomerInternal(): void {
			if (this.customer.defaultPaymentType?.id) {
				this.model = this.customer.defaultPaymentType.id;
			} else {
				this.model = null;
			}
			this.valid = true;
		}

		private paymentTypeName(paymentType: IPaymentTypeShopListEntry): string | null {
			return TranslatedValueHelper.get(paymentType.name, this.$i18n.locale);
		}

		private requestSave(): void {
			if (this.model === null) return;
			this.loading = true;
			this.$customerServiceShop.setDefaultPaymentType(this.customer.id, this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		private loadPaymentTypes(): void {this.$paymentTypeServiceShop.paymentTypes(null, null)
			.then(data => this.paymentTypes = data.data)
			.catch(() => Snackbar.loadingError());

		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
